import type { Commons, Scene, TrialSubmit } from '../../shared/scene';

export interface AppConfig {
  ok: boolean;
  turnstileSiteKey: string;
  consentLine: string;
  appSlug: string;
  devTurnstileBypass?: boolean;
}

async function requestJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  const data = (await response.json()) as T & { ok?: boolean; error?: string; detail?: string };
  if (!response.ok || data.ok === false) {
    throw new Error(data.error || data.detail || `HTTP ${response.status}`);
  }
  return data;
}

export async function getConfig(): Promise<AppConfig> {
  return requestJson<AppConfig>('/api/config');
}

export async function getScene(): Promise<Scene> {
  const data = await requestJson<{ ok: true; scene: Scene }>(`/api/scene?seed=${encodeURIComponent(crypto.randomUUID())}`);
  return data.scene;
}

export async function submitTrial(payload: TrialSubmit): Promise<{ self: SelfReport; commons: Commons }> {
  const data = await requestJson<{ ok: true; self: SelfReport; commons: Commons }>('/api/submit', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload)
  });
  return { self: data.self, commons: data.commons };
}

export async function getCommons(sceneId?: string): Promise<Commons> {
  const suffix = sceneId ? `?sceneId=${encodeURIComponent(sceneId)}` : '';
  const data = await requestJson<{ ok: true; commons: Commons }>(`/api/commons${suffix}`);
  return data.commons;
}

export interface SelfReport {
  trialId: string;
  countError: number;
  missed: boolean;
  blindspotClass: string;
  attentionalLoad: number;
  message: string;
}
